module.exports = __webpack_public_path__ + "img/box.022281b5.png";